import { render, staticRenderFns } from "./TemplateSpaces.vue?vue&type=template&id=48d5a946&scoped=true"
import script from "./TemplateSpaces.vue?vue&type=script&lang=js"
export * from "./TemplateSpaces.vue?vue&type=script&lang=js"
import style0 from "./TemplateSpaces.vue?vue&type=style&index=0&id=48d5a946&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48d5a946",
  null
  
)

export default component.exports